/* Project Import will be here */
import { post, IRequest } from "../index";
import { ISalesReturnProducts, ISalesReturnUpload } from "models/salesReturnModels";
/* Project Import will be here */

/* Get the sales return products to show in the sales return product list page */
export const getSalesReturnProductListApi = (data: ISalesReturnProducts) => {
    const request: IRequest = { subUrl: `/SalesReturn/ProductList`, data };
    return post(request);
};

/* Get the uploaded sales return product summary */
export const getSalesReturnSummaryApi = (data) => {
    const request: IRequest = { subUrl: `/SalesReturn/ReturnSummary`, data };
    return post(request);
};

/* Upload the products to the sales return */
export const uploadSalesReturnApi = (data: List<ISalesReturnUpload>) => {
    const request: IRequest = { subUrl: `/SalesReturn/ReturnUpload`, data };
    return post(request);
};

/* clear all the products in the sales return */
export const clearAllSalesReturnApi = () => {
    const request: IRequest = { subUrl: `/SalesReturn/ClearCart` };
    return post(request);
};

/* Submit the products to the sales return */
export const submitSalesReturnApi = (data: ISalesReturnSubmit) => {
    const request: IRequest = { subUrl: `/SalesReturn/ReturnSubmit`, data };
    return post(request);
};

/* Get sales return return reasons */
export const getSalesReturnReasonsApi = () => {
    const request: IRequest = { subUrl: `/SalesReturn/ReasonMaster` };
    return post(request);
};

/* Get exchange return - Return reasons */
export const getExchangeReturnReasonsApi = () => {
    const request: IRequest = { subUrl: `/SalesReturn/ExReasonMaster` };
    return post(request);
};